export default "__VITE_ASSET__Dk8IVEH0__"